<template lang="pug">
.card
  .card-body
    .columns.align-items-center
      .column
        text-output(label="Descrição", :text="debito.descricao")
    .text-error
      text-output(label="Valor", :text="debito.valor | currency('R$')")
</template>

<script>
export default {
  props: { debito: { type: Object, required: true } },
};
</script>
